import config from '../../../config/index';
import { BINGO_GAMES_ID } from '../../../model/constants';
import { LogicContext } from '../types';
import { divideGameListToSlides } from '../utils';

export const prepareBingoGamesContent = async (context: LogicContext) => {
  const { bingoGames = [], controllersData, callbackMode, user } = context;
  const gameDetailsInfo = config.features.gameDetails.mode === 'enabled';

  if (!controllersData || !controllersData.bingoGames) {
    return { updates: [] };
  }

  const { components } = controllersData.bingoGames;

  const isBingoGamesVisible = bingoGames.length > 0;

  const updates = components.map(([id, cmp]) => {
    const {
      title,
      description,
      play_bingo_button,
      staticTexts,
    } = cmp.properties;

    const category = {
      id: BINGO_GAMES_ID,
      view_all_button_visible: false,
      title,
      description,
      games: bingoGames,
      gameDetailsInfo,
      staticTexts,
      type: 'Extended Single Block',
      component_type: 'game_grid',
      slides: divideGameListToSlides({
        gameList: bingoGames,
        slideType: 'Extended Single Block',
      }),
    };

    return {
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: {
          category: isBingoGamesVisible ? category : undefined,
          animation: false,
          visible: isBingoGamesVisible,
          callbackMode,
          displayInMainSection: !!context.currentLayout?.components
            .SideNavigation,
          playButtonLabel: play_bingo_button.label,
          playButtonLabelVisible: play_bingo_button.visible && user.loggedIn,
          locale: config.locale,
          jurisdiction: config.jurisdiction,
          loggedIn: user.loggedIn,
        },
      },
    };
  });

  return { updates };
};
